import classNames from 'classnames';
import { MAX_LABEL_ITEMS } from './constants';
import styles from '@app/modules/projects/dashboard/shared/per-year-capital-structure/per-year-capital-structure-chart.module.scss';
import { FC } from 'react';
import { amountValueFormatterProps, abbreviatedValueFormatter } from '@app/shared/formatters';

interface HorizontalGridLinesProps {
  labelTopValue: number;
  numberOfGridLines: number;
  multiplier: number;
  negative?: boolean;
}

const PARENT_CLASSNAME = 'total-equity-chart';

const HorizontalGridLines: FC<HorizontalGridLinesProps> = ({
  labelTopValue,
  numberOfGridLines,
  multiplier,
  negative = false,
}) => {
  const adjustIndexForPositiveGridLine = (index: number) => (negative ? index : index + 1);

  const getValueForGridLine = (index: number) => {
    return negative
      ? (labelTopValue / MAX_LABEL_ITEMS) * -index * multiplier
      : (labelTopValue / MAX_LABEL_ITEMS) * adjustIndexForPositiveGridLine(index) * multiplier;
  };

  if (numberOfGridLines <= 0) {
    return null;
  }

  return (
    <>
      {Array.from({ length: numberOfGridLines }).map((_, i) => (
        <div
          key={`grid-line-${negative ? 'neg' : 'pos'}-${i}`}
          className={classNames([
            styles[`${PARENT_CLASSNAME}__grid-line`],
            styles[`${PARENT_CLASSNAME}__grid-line--${adjustIndexForPositiveGridLine(i)}`],
            {
              [styles[`${PARENT_CLASSNAME}__grid-line--${i}-negative`]]: negative,
            },
          ])}
          data-grid-value={abbreviatedValueFormatter({
            value: getValueForGridLine(i),
            ...amountValueFormatterProps,
          })}
        />
      ))}
    </>
  );
};

export default HorizontalGridLines;
